"use strict";
/*
 * Created on 2019-04-11
 */

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var DataObjectConverter_1 = require("../../../core/conversions/DataObjectConverter");
/**
 * @author JMr
 */


var SelloutReleaseCategoryTotalDTOConverter =
/*#__PURE__*/
function (_DataObjectConverter_) {
  _inherits(SelloutReleaseCategoryTotalDTOConverter, _DataObjectConverter_);

  function SelloutReleaseCategoryTotalDTOConverter() {
    _classCallCheck(this, SelloutReleaseCategoryTotalDTOConverter);

    return _possibleConstructorReturn(this, _getPrototypeOf(SelloutReleaseCategoryTotalDTOConverter).apply(this, arguments));
  }

  return SelloutReleaseCategoryTotalDTOConverter;
}(DataObjectConverter_1.DataObjectConverter);

exports.SelloutReleaseCategoryTotalDTOConverter = SelloutReleaseCategoryTotalDTOConverter;